import { render, staticRenderFns } from "./SentDraft.vue?vue&type=template&id=2b4cfa33&scoped=true&"
import script from "./SentDraft.vue?vue&type=script&lang=js&"
export * from "./SentDraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4cfa33",
  null
  
)

export default component.exports